import { HttpClient, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID, inject } from "@angular/core";
import { AUTH_TYPE_HEADER, Addon, AddonType } from "ngx-exdr-stmx-common";
import { Observable, map, of, switchMap } from "rxjs";
import { httpAuthTechnadoptInterceptorFn } from "ngx-exdr-stmx-technadopt/interceptors";
import { DOCUMENT, isPlatformServer, PlatformLocation } from "@angular/common";
import { environment } from "../../../environments/environment";
import { httpAuthIdenediInterceptorFn } from "ngx-exdr-stmx-idenedi/interceptors";
import { HeaderService } from "../services/header.service";

@Injectable({
  providedIn: "root"
})
class HttpAuthInterceptorService {
  constructor(
    @Inject(DOCUMENT) public document: Document,
    private httpClient: HttpClient,
    @Inject(PLATFORM_ID) private platformId: string,
    private platformLocation: PlatformLocation,
    private headerService: HeaderService
  ) { }

  getGroupIdByDomain(doamin: string): Observable<string> {    
    const url = `${environment.apiHost}/api/reverselookup/CustomDomain?value=${doamin}`;
    return this.httpClient.get<string>(url);
  }

  getGroupId(): Observable<string> {
    let url;
    if(isPlatformServer(this.platformId)){
      const xForwardedHost = this.headerService.getHeader('X-Forwarded-Host');
      console.log("X-Forwarded-Host:", xForwardedHost);
      if(xForwardedHost) {
        url = xForwardedHost;
      } else {
        const location = this.platformLocation as any;
        url = `${location.hostname}`;
        //url = `istemexe2.stagbeta.stemexe.com`;      
      }    
    }else{
      url = this.document.location.host;
      //url = `istemexe2.stagbeta.stemexe.com`;   
    }       
    
    return this.getGroupIdByDomain(url).pipe(
      map((groupId) => {        
        return groupId;
      })
    );
  }

  getAddonsByGroupId(groupId: string): Observable<Addon[]>{
    const url = `${environment.apiHost}/api/group/${groupId}/addon`;
    let request$: Observable<Addon[]>;    
    request$ = this.httpClient.get<any>(url);
    
    return request$.pipe(
      map((addons: any[]) => {
        return addons;
      })
    );
  }  
  

  getAddons(): Observable<Addon[]> {
    return this.getGroupId().pipe(
      switchMap(groupId => this.getAddonsByGroupId(groupId))
    )
  }
}

export const httpAuthInterceptorFn: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<any> => {
  const httpAuthInterceptorService = inject(HttpAuthInterceptorService);
  const authType = getAuthType(req);  
  if (authType.toLowerCase() == AuthType.Technadopt.toLowerCase()) {
    return httpAuthInterceptorService.getAddons().pipe(
      switchMap(addons => { 
        const addon = addons.find(a => a.Type.toLowerCase() === AddonType.Technadopt.toLowerCase());
        return httpAuthTechnadoptInterceptorFn(<any>req, <any>next, addon);                
        // return ''
      })
    )
  } else if (authType.toLowerCase() == AuthType.Idenedi.toLowerCase()) {
    return httpAuthInterceptorService.getAddons().pipe(
      switchMap(addons => { 
        const addon = addons.find(a => a.Type.toLowerCase() === AddonType.Technadopt.toLowerCase());
        return httpAuthIdenediInterceptorFn(req, next, addon);
        // return ''        
      })
    )
  } else {
    return next(req);
  }
};  

function getAuthType(request: HttpRequest<any>): AuthType {
  return (request.headers.get(AUTH_TYPE_HEADER) as AuthType) || AuthType.None;
}

export enum AuthType {
  None = "none",
  Technadopt = "technadopt",
  Idenedi = "idenedi",
}

 